// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const wartortle: PokeData = {
  "id": 8,
  "name": "wartortle",
  "height": 10,
  "weight": 225,
  "base_experience": 142,
  "types": [
    PokeType.WATER
  ],
  "api_moves": [
    "headbutt",
    "tackle",
    "tail-whip",
    "bite",
    "water-gun",
    "hydro-pump",
    "bubble-beam",
    "withdraw",
    "skull-bash",
    "bubble",
    "protect",
    "rapid-spin",
    "rain-dance",
    "iron-defense",
    "water-pulse",
    "aqua-tail",
    "shell-smash",
    "wave-crash"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "bite",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "protect",
    "rain-dance",
    "aqua-tail",
    "liquidation",
    "aqua-cutter",
    "life-dew",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 3,
    "item": null,
    "species": [
      {
        "name": "squirtle",
        "order": 7,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "wartortle",
        "order": 8,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 7,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 16,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "blastoise",
        "order": 9,
        "types": [
          PokeType.WATER
        ],
        "evolves_from_species_id": 8,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 69.5,
    "speed": 58,
    "ability_power": 65
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
